import { WidgetConfig } from '../../components/elements/Draggable';
import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetChart {
  StartDate: string;
  EndDate: string;
}

interface GetYear {
  YearFrom: string;
  YearTo: string;
}
interface GetChartPlan extends GetChart {
  Bulan?: string;
  Tahun?: string;
  Year?: string;
  Month?: string;
  BuName?: string;
  SubBuName?: string;
  BinusianId?: string;
  DeptName?: string;
  Role?: string;
  bulan?: string;
  tahun?: string;
  Status?: string;
  BuCode?: string;
  SubBuCode?: string;
  DeptCode?: string;
  CourseId?: string;
  Program?: string;
  SectionName?: string;
  SectionCode?: string;
}

interface GetChartYear extends GetYear{
  Bulan?: string;
  Tahun?: string;
  Year?: string;
  Month?: string;
  BuName?: string;
  SubBuName?: string;
  BinusianId?: string;
  DeptName?: string;
  TypeTask?: string;
  bulan?: string;
  tahun?: string;
  Status?: string;
  BuCode?: string;
  SubBuCode?: string;
  DeptCode?: string;
  CourseId?: string;
  Program?: string;
  SectionName?: string;
  SectionCode?: string;
  JobBand?: string;
}
export const getChartTSI = ({
  StartDate,
  EndDate,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName,
  Role,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}: GetChartPlan) => {
  return HttpService.post(ApiService.icdc.module.dashboardprincipal.chartTSI, {
    StartDate,
    EndDate,
    Month: Bulan,
    SubBuName,
    BinusianId,
    Year: Tahun,
    DeptName,
    Role,
    BuCode,
    SubBuCode,
    DeptCode,
    SectionCode,
    SectionName
  });
};

export const downloadChartTSI = ({
  StartDate,
  EndDate,
  BuName,
  BinusianId,
  Bulan,
  SubBuName,
  Tahun,
  Status,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName,
  DeptName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.downloadChartTSI,
    {
      StartDate,
      EndDate,
      BuName,
      BinusianId,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      Status,
      BuCode,
      SubBuCode,
      DeptCode,
      DeptName,
      SectionCode,
      SectionName
    }
  );
};

export const getChartCTM = ({
  YearFrom,
  YearTo,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName,
  TypeTask,
  BuCode,
  SubBuCode,
  DeptCode,
  JobBand
}: GetChartYear) => {
  return HttpService.post(ApiService.icdc.module.dashboardprincipal.chartCTM, {
    YearFrom,
    YearTo,
    Month: Bulan,
    SubBuName,
    BinusianId,
    Year: Tahun,
    DeptName,
    Type: TypeTask,
    BuCode,
    SubBuCode,
    DeptCode,
    JobBand
  });
};

export const downloadChartCTM = ({
  YearFrom,
  YearTo,
  TypeTask,
  BuName,
  BinusianId,
  Bulan,
  SubBuName,
  Tahun,
  Status,
  BuCode,
  SubBuCode,
  DeptCode,
  JobBand
}: GetChartYear) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.downloadChartCTM,
    {
      YearFrom,
      YearTo,
      TypeTask,
      BuName,
      BinusianId,
      Bulan,
      SubBuName,
      Year: Tahun,
      Status,
      BuCode,
      SubBuCode,
      DeptCode,
      JobBand
    }
  );
};

export const getChartBudget = ({
  StartDate,
  EndDate,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName,
  Role,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.chartBudget,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      SubBuName,
      BinusianId,
      Year: Tahun,
      DeptName,
      Role,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const downloadChartBudget = ({
  StartDate,
  EndDate,
  BuName,
  BinusianId,
  Bulan,
  SubBuName,
  Tahun,
  Status,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.downloadChartBudget,
    {
      StartDate,
      EndDate,
      BuName,
      BinusianId,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      Status,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName
    }
  );
};

export const getChartProgramMonitoring = ({
  StartDate,
  EndDate,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName,
  Role,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  Program
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.chartProgramMonitoring,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      SubBuName,
      BinusianId,
      Year: Tahun,
      DeptName,
      Role,
      SubBuCode,
      DeptCode,
      SectionCode,
      Program
    }
  );
};

export const downloadChartProgramMonitoringSE = ({
  StartDate,
  EndDate,
  BinusianId,
  Bulan,
  SubBuName,
  Tahun,
  Status,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName,
  Program
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal
      .downloadChartProgramMonitoringSOENGLISH,
    {
      StartDate,
      EndDate,
      BinusianId,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      Status,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName,
      Program
    }
  );
};

export const downloadChartProgramMonitoringSK12 = ({
  StartDate,
  EndDate,
  BuName,
  BinusianId,
  Bulan,
  SubBuName,
  Tahun,
  Status,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal
      .downloadChartProgramMonitoringSK12,
    {
      StartDate,
      EndDate,
      BuName,
      BinusianId,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      Status,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName
    }
  );
};
export const downloadChartProgramMonitoringBCC = ({
  StartDate,
  EndDate,
  BuName,
  BinusianId,
  Bulan,
  SubBuName,
  Tahun,
  Status,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.downloadChartProgramMonitoringBCC,
    {
      StartDate,
      EndDate,
      BuName,
      BinusianId,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      Status,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName
    }
  );
};

export const getChartRater = ({
  YearFrom,
  YearTo,
  Bulan,
  SubBuName,
  BinusianId,
  Tahun,
  DeptName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartYear) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.chartRater,
    {
      StartYear: YearFrom,
      EndYear: YearTo ,
      SubBuName,
      BinusianId,
      Year: Tahun,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const downloadChartRater = ({
  YearFrom,
  YearTo,
  BuName,
  BinusianId,
  Bulan,
  SubBuName,
  Tahun,
  Status,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}: GetChartYear) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.downloadChartRater,
    {
      YearFrom,
      YearTo,
      BuName,
      BinusianId,
      Bulan,
      SubBuName,
      Year: Tahun,
      Status,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName
    }
  );
};

interface PostWidget {
  binusianId: string;
  data: WidgetConfig[];
}

export const postWidgetConfiguration = (data: PostWidget) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardprincipal.updateWidget,
    { binusianID: data.binusianId, data: data.data }
  );
};

interface ParamsConfig {
  binusianId: string;
}

export const getListWidget = ({ binusianId }: ParamsConfig) => {
  return HttpService.get(
    `${ApiService.icdc.module.dashboardprincipal.listWidget}?binusianId=${binusianId}`
  );
};
